import { ReduxActionType } from '../../components/ssap/SsapTypes';

const CLEAR_DASHBOARD_STATE: ReduxActionType = 'CLEAR_DASHBOARD_STATE';

const SET_DASHBOARD_MODELS: string = 'SET_DASHBOARD_MODELS';
const CHANGE_DASHBOARD_MODELS: string = 'CHANGE_DASHBOARD_MODELS';

// TODO: move ReduxActionTypeValuesObject to common types when they are located somewhere
interface ReduxActionTypeValuesObject {
    [ key: string ]: ReduxActionType
}

export const DASHBOARD_MODELS_ACTION_TYPES = {
    SET_DASHBOARD_MODELS,
    CHANGE_DASHBOARD_MODELS,
    CLEAR_DASHBOARD_STATE
};

const SET_ACTIVE_HOUSEHOLD: string = 'SET_ACTIVE_HOUSEHOLD';

export const MULTIHOUSEHOLD_ACTION_TYPES = {
    SET_ACTIVE_HOUSEHOLD,
    CLEAR_DASHBOARD_STATE
};

const SET_ACTIVE_TAB: string = 'SET_ACTIVE_TAB';

export const TAB_ACTION_TYPES = {
    SET_ACTIVE_TAB,
    CLEAR_DASHBOARD_STATE
};

export const SET_CTA_TYPE: string = 'SET_CTA_TYPE';

export const CTA_ACTION_TYPES = {
    SET_CTA_TYPE,
    CLEAR_DASHBOARD_STATE
};

export const SET_VERIFY_ACCESS_CODE_TYPE: string = 'SET_VERIFY_ACCESS_CODE_TYPE';

export const VERIFY_ACCESS_CODE_TYPE = {
    SET_VERIFY_ACCESS_CODE_TYPE,
    CLEAR_DASHBOARD_STATE
};

export const SET_COMMUNICATION_PREFERENCES: ReduxActionType = 'SET_COMMUNICATION_PREFERENCES';
export const SET_LANGUAGES: ReduxActionType = 'SET_LANGUAGES';

export const COMMUNICATION_PREFERENCES_ACTION_TYPES: ReduxActionTypeValuesObject = {
    SET_COMMUNICATION_PREFERENCES,
    SET_LANGUAGES,
    CLEAR_DASHBOARD_STATE
};


// communicationPreferencesSagaActionTypes

const FETCH_COMMUNICATION_PREFERENCES: ReduxActionType = 'FETCH_COMMUNICATION_PREFERENCES';
const FETCH_COMMUNICATION_PREFERENCES_FAILURE: ReduxActionType = 'FETCH_COMMUNICATION_PREFERENCES_FAILURE';
const FETCH_COMMUNICATION_PREFERENCES_START: ReduxActionType = 'FETCH_COMMUNICATION_PREFERENCES_START';
const FETCH_COMMUNICATION_PREFERENCES_SUCCESS: ReduxActionType = 'FETCH_COMMUNICATION_PREFERENCES_SUCCESS';

export const communicationPreferencesSagaActionTypes: ReduxActionTypeValuesObject = {
    FETCH_COMMUNICATION_PREFERENCES,
    FETCH_COMMUNICATION_PREFERENCES_FAILURE,
    FETCH_COMMUNICATION_PREFERENCES_START,
    FETCH_COMMUNICATION_PREFERENCES_SUCCESS
};

// languagesSagaActionTypes

const FETCH_LANGUAGES: ReduxActionType = 'FETCH_LANGUAGES';
const FETCH_LANGUAGES_FAILURE: ReduxActionType = 'FETCH_LANGUAGES_FAILURE';
const FETCH_LANGUAGES_START: ReduxActionType = 'FETCH_LANGUAGES_START';
const FETCH_LANGUAGES_SUCCESS: ReduxActionType = 'FETCH_LANGUAGES_SUCCESS';

export const languagesSagaActionTypes: ReduxActionTypeValuesObject = {
    FETCH_LANGUAGES,
    FETCH_LANGUAGES_FAILURE,
    FETCH_LANGUAGES_START,
    FETCH_LANGUAGES_SUCCESS
};
